import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { X } from 'lucide-react';

import image1 from '../assest/Gallery/image1.png';
import image7 from '../assest/capms/Kondaveedu/image4.png';
import image2 from '../assest/mobileclinics/BISWABHUSHAN/image2.png';
import image4 from '../assest/Gallery/image4.png';
import image3 from '../assest/Gallery/image3.jpg';
import image5 from '../assest/capms/Kondaveedu/image3.png';
import image6 from '../assest/Gallery/image6.png';
import image8 from '../assest/capms/Bhavanipuram/image1.png';
import collageImage from '../assest/collage/dental-collage-blur.png';

import { useNavigate } from "react-router-dom";

const fadeUp = {
  hidden: { opacity: 0, y: 60 },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.8,
      ease: "easeOut"
    }
  }
};

const Gallery = () => {
  const [selectedImg, setSelectedImg] = useState(null);
  const navigate = useNavigate();

  const images = [
    {
      id: 1,
      url: image2,
      title: 'Free Rural Dental Camps',
      size: 'large'
    },
    {
      id: 2,
      url: image1,
      title: 'ACHIEVED GUINNESS WORLD RECORD',
      size: 'small'
    },
    {
      id: 3,
      url: image3,
      title: 'Inauguration',
      size: 'small'
    },
    {
      id: 4,
      url: image4,
      title: 'Blood Donation Camp',
      size: 'small'
    },
    {
      id: 5,
      url: image5,
      title: 'Free check-up',
      size: 'small'
    },
    {
      id: 6,
      url: image6,
      title: 'Free Dental Health-Camp',
      size: 'medium'
    },
    {
      id: 7,
      url: image7,
      title: 'Smart Checkup',
      size: 'small'
    },
    {
      id: 8,
      url: image8,
      title: 'Mobile health camp',
      size: 'small'
    },
    {
      id: 9,
      url: collageImage,
      title: 'VIEW MORE',
      size: 'medium',
      isViewMore: true
    }
  ];

  return (
    <motion.div
      className="p-4 md:p-8 bg-gray-50 "
      initial="hidden"
      whileInView="visible"
      viewport={{ once: true, amount: 0.2 }}
      variants={fadeUp}
    >
      <div className="max-w-7xl mx-auto">

        {/* Header */}
        <motion.div
          className="mb-10 text-center"
          variants={fadeUp}
        >
          <h1 className="text-4xl font-bold text-gray-800">
            Visual Portfolio
          </h1>

          <p className="text-gray-500 mt-2">
            A collection of captured moments
          </p>
        </motion.div>

        {/* Gallery Grid */}
        <div className="relative z-10 grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-3 xl:grid-cols-4 gap-4 auto-rows-[250px]">

          {images.map((img, index) => (
            <motion.div
              key={img.id}
              onClick={() =>
                img.isViewMore
                  ? navigate('/viewmore')
                  : setSelectedImg(img.url)
              }
              className={`
                relative
                group
                overflow-hidden
                rounded-2xl
                cursor-pointer
                shadow-lg
                transition-all
                duration-300
                hover:shadow-2xl

                ${img.size === 'large' ? 'md:row-span-2' : ''}
                ${img.size === 'medium' ? 'md:col-span-2' : ''}
              `}
              initial={{ opacity: 0, y: 60 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.2 }}
              transition={{
                duration: 0.6,
                delay: index * 0.1
              }}
            >
              {/* Image */}
              <motion.img
                src={img.url}
                alt={img.title}
                className="w-full h-full object-cover"
                whileHover={{
                  scale: 1.08
                }}
                transition={{
                  duration: 0.5
                }}
              />

              {/* Regular Images Overlay */}
              {!img.isViewMore && (
                <div className="absolute inset-0 bg-black/40 opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                  <div className="flex items-end h-full p-6">
                    <p className="text-white font-medium text-lg translate-y-4 group-hover:translate-y-0 transition-transform duration-300">
                      {img.title}
                    </p>
                  </div>
                </div>
              )}

              {/* View More Card */}
              {img.isViewMore && (
                <>
                  <div className="absolute inset-0 bg-black/20" />

                  <motion.div
                    className="
                      absolute
                      bottom-5
                      right-5
                      z-20
                    "
                    whileHover={{
                      scale: 1.08,
                      y: -3
                    }}
                    transition={{
                      duration: 0.25
                    }}
                  >
                    <button
                      className="
                        bg-blue-600
                        hover:bg-blue-700
                        text-white
                        px-5
                        py-3
                        rounded-full
                        font-semibold
                        flex
                        items-center
                        gap-2
                        shadow-xl
                        transition-all
                        duration-300
                      "
                    >
                      <span>VIEW MORE</span>
                      <span className="text-lg">→</span>
                    </button>
                  </motion.div>
                </>
              )}

            </motion.div>
          ))}

        </div>
      </div>

      {/* Lightbox */}
      <AnimatePresence>
        {selectedImg && (
          <motion.div
            className="fixed inset-0 z-50 flex items-center justify-center bg-black/90 p-4"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            onClick={() => setSelectedImg(null)}
          >
            <motion.button
              className="absolute top-6 right-6 text-white hover:text-gray-300"
              onClick={() => setSelectedImg(null)}
              whileHover={{ scale: 1.2 }}
            >
              <X size={40} />
            </motion.button>

            <motion.img
              src={selectedImg}
              alt="Enlarged"
              className="max-w-full max-h-full rounded-lg shadow-2xl"
              initial={{ scale: 0.8 }}
              animate={{ scale: 1 }}
              exit={{ scale: 0.8 }}
              transition={{ duration: 0.3 }}
            />
          </motion.div>
        )}
      </AnimatePresence>

    </motion.div>
  );
};

export default Gallery;